<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong>Адреса начала работы курьеров в Москва-Сити</strong>
                </CCardHeader>

                <CCardBody>
                    <table class="table">
                        <thead>
                            <th>Башня</th>
                            <th>Показывать</th>
                        </thead>
                        <tbody>
                            <tr v-for="item in list" :key="item.id">
                                <td>
                                    {{ item.name }}
                                </td>
                                <td>
                                    <CSwitch
                                        :checked.sync="item.enabled"
                                        name="dayEnabled"
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-2"
                        @click="saveData"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>
<script>
    export default {
        name: 'TowerTime',

        data: () => ({
            list: [],
        }),

        computed: {},

        mounted() {
            this.updateData();
        },

        methods: {
            async updateData() {
                try {
                    const { data } = await this.axios.get('/couriers/service/start-towers');
                    this.list = data;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            async saveData() {
                try {
                    const towers = this.list.map(tower => ({
                        id: tower?.id || null,
                        tower_id: tower.tower_id,
                        enabled: tower.enabled
                    }));
                    await this.axios.post('/couriers/service/start-towers', { towers });
                    this.$router.push({ path: '/courier-service' });
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            goBack() {
                this.$router.push({ path: '/courier-service' });
            }
        },
    };
</script>
